import React from 'react'
import { Container } from '../../../components'
import { Link } from 'react-router-dom'

import resources from '../../../database/resource-categories.json'

const MainContent = () => {
  return (
    <Container>
      <div className="py-12 lg:py-24 flex flex-wrap -mx-2 lg:-mx-4">
        {
          resources.map((r, i) => (
            <div className="w-1/2 lg:w-1/4 px-2 lg:px-4 mb-4 lg:mb-8 h-auto" key={i}>
              <Link to={`/resource/${r.slug}`} className="block h-full">
                <div className="p-5 lg:pt-16 lg:pb-12 text-center rounded h-full cursor-pointer" style={{boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)'}}>
                  <img src={r.image} alt={r.name} className="mb-4 lg:mb-8 mx-auto" style={{maxWidth: '80px'}}/>
                  <p className="text-lg lg:text-2xl font-bold">{ r.name }</p>
                </div>
              </Link>
            </div>
          ))
        }
        <div className="w-1/2 lg:w-1/4 px-2 lg:px-4 mb-4 lg:mb-8 h-auto">
          <Link to={`/program`} className="block h-full">
            <div className="p-5 lg:pt-16 lg:pb-12 text-center rounded h-full cursor-pointer" style={{boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)'}}>
              <img src={`/images/resource-icon/i-KHUB-_icons-Inisiatif.png`} alt={`Inisiatif`} className="mb-4 lg:mb-8 mx-auto" style={{maxWidth: '80px'}}/>
              <p className="text-lg lg:text-2xl font-bold">Inisiatif</p>
            </div>
          </Link>
        </div>
      </div>
    </Container>
  )
}

export { MainContent }
